<section class="w-25 mx-auto my-5">
  @if(loading())
  {
    <div>
    <mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
  </div>
  }
  @else
  {
    <mat-card>
      <form>
        <mat-card-title>Log In</mat-card-title>
  
        <mat-card-content>
          @if (error) {
            <p class="text-danger" role="alert">{{ error }}</p>
          }

          <mat-form-field class="w-100">
            <input matInput placeholder="Email" type="email" [formControl]="signInForm.get('email')" required>
            <mat-error *ngIf="formService.controlHasError( signInForm.get('email'), 'required')">This field is required
            </mat-error>
            <mat-error *ngIf="formService.controlHasError( signInForm.get('email'), 'email')">This field should be
              a valid email
            </mat-error>
          </mat-form-field>
  
          <mat-form-field class="w-100">
            <input matInput placeholder="Password" type="password" [formControl]="signInForm.get('password')" required>
            <mat-error *ngIf="formService.controlHasError( signInForm.get('password'), 'required')">This field is required
            </mat-error>
          </mat-form-field>
        </mat-card-content>
  
        <mat-card-actions>
          <button mat-raised-button color="primary" (click)="submitForm()">Log In</button>
        </mat-card-actions>
  
      </form>
    </mat-card>
  }
</section>

